/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {ServiceDrivenFieldViewer} from "./ServiceDrivenFieldViewer";
import {service as ConservationActionService} from "../../../Services/ConservationActionService";
import {StreamBankLink} from "../../../Components/Common/StreamBankLink";
import React from "react";

const _ConservationActionLinkFieldViewer = ServiceDrivenFieldViewer(ConservationActionService);

export const ConservationActionLinkFieldViewer = (props) => {
	const {Value, Data, RootData} = props;

	const conservationActionId = Value ?? Data?.conservationActionId;
	const conservationActionPermit = RootData?.ConservationActionPermits[0];

	if (!conservationActionPermit || !conservationActionId) {
		return 'N/A';
	}

	return <StreamBankLink className="sb-actionable-link" Href={conservationActionPermit.ConservationAction.ContextNodeDetails.link + '/permit'}>
		<_ConservationActionLinkFieldViewer
			{...props}
			Value={conservationActionId}
		/>
	</StreamBankLink>;
}